

const onExecutionMessageReceived = (nodes, edges, data, showAnimations, wsNodeRef, setNodes,
	setCurrentExecutionId, setIsExecutionDetailsShown, setIsAnimationOptionShown, showExecutionToast, callSetRead, reqLatestExecutions) => {

	if (data.data?.session_id && data.data?.session_id != sessionStorage.getItem("execution_session_id")) return;

	const exception = data.data.exception;
	const status = data.data.status;
	const executionId = data.data.execution_id;
	const executionNodeId = data.data.node_id;
	const lastNode = data.data.last_node;
	const message = data.data.message;
	const awaitingAlert = data.data.awaiting_alert;
	const executionSessionId = data.data.session_id;

	callSetRead({ id: executionId, isRead: true });
	// showExecutionToast({
	// 	exception, status, executionId, executionNodeId, message, lastNode,
	// 	awaitingAlert, nodes, executionSessionId, setIsExecutionDetailsShown, setCurrentExecutionId
	// });
	reqLatestExecutions.refetch();

	if (status == "RUNNING") {

		wsNodeRef.current.suscribe(`NODE_STATUS_${executionId}`);

		setIsAnimationOptionShown(true);
		if (!showAnimations) return;

		const visited = new Set();
		const parentNode = nodes.find((node) => node.remoteId == executionNodeId)
		const queue = [];
		if (parentNode) queue.push(parentNode.id);

		while (queue.length > 0) {

			const nodeId = queue.shift();
			const node = nodes.find((node) => node.id == nodeId);
			if (!node) continue;

			if (visited.has(nodeId)) continue;
			visited.add(nodeId);

			for (const edge of edges)
				if (edge.source == nodeId)
					queue.push(edge.target);

		}

		setNodes((nodes) => nodes.map((node) => {

			if (visited.has(node.id)) {

				if (node.data.currentExecution != executionId) {
					node.data.status = null;
					node.data.message = null;
				}

				node.data.currentExecution = executionId;

			}

			return node;

		}));

	}
	else if (status == "OK" || status == "FAILED") {

		wsNodeRef.current.unsuscribe();

		setTimeout(() => {
			setIsAnimationOptionShown(false);
		}, 4000);

		setNodes((nodes) => nodes.map((node) => {
			node.data.currentExecution = null;
			node.data.status = null;
			node.data.message = null;
			return node;
		}));

	}

}

const onNodeMessageReceived = (data, setNodes) => {

	if (data.data?.session_id && data.data?.session_id != sessionStorage.getItem("execution_session_id")) return;

	const status = data.data.status;
	const nodeId = data.data.node_id;
	const message = data.data.message;

	setNodes((nodes) => nodes.map((node) => {
		if (node.remoteId == nodeId) {
			node.data.status = status;
			node.data.message = message;
		}
		return node;
	}))

}

export { onExecutionMessageReceived, onNodeMessageReceived };